import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Pages } from 'constants/menu'
import { TabOption } from '@urbanx/agx.ui-components2'

export enum SelectedPartnersTab {
    Partner = 'Partner',
    Individuals = 'Individuals',
    Leaderboard = 'Leaderboard',
}

const getSelectedTabFromPath = (pathname: string): SelectedPartnersTab => {
    if (
        pathname.endsWith(`/${Pages.REPORTING_PARTNERS_PARTNER}`) ||
        pathname.includes(`/${Pages.REPORTING_PARTNERS_PARTNER}/`)
    ) {
        return SelectedPartnersTab.Partner
    }

    if (
        pathname.endsWith(`/${Pages.REPORTING_PARTNERS_INDIVIDUALS}`) ||
        pathname.includes(`/${Pages.REPORTING_PARTNERS_INDIVIDUALS}/`)
    ) {
        return SelectedPartnersTab.Individuals
    }

    if (
        pathname.endsWith(`/${Pages.REPORTING_PARTNERS_LEADERBOARD}`) ||
        pathname.includes(`/${Pages.REPORTING_PARTNERS_LEADERBOARD}/`)
    ) {
        return SelectedPartnersTab.Leaderboard
    }

    return SelectedPartnersTab.Partner
}

const usePartnersPage = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const selectedTab = useMemo(() => {
        return getSelectedTabFromPath(location.pathname)
    }, [location.pathname])

    const tabOptions: TabOption[] = useMemo(
        () => [
            {
                label: SelectedPartnersTab.Partner.toString(),
                id: SelectedPartnersTab.Partner.toString(),
                selected: selectedTab === SelectedPartnersTab.Partner,
            },
            {
                label: SelectedPartnersTab.Individuals.toString(),
                id: SelectedPartnersTab.Individuals.toString(),
                selected: selectedTab === SelectedPartnersTab.Individuals,
            },
            {
                label: SelectedPartnersTab.Leaderboard.toString(),
                id: SelectedPartnersTab.Leaderboard.toString(),
                selected: selectedTab === SelectedPartnersTab.Leaderboard,
            },
        ],
        [selectedTab]
    )

    const onTabChange = useCallback(
        (tabOption: TabOption) => {
            const tab = tabOption.id as SelectedPartnersTab

            if (tab === selectedTab) return

            switch (tab) {
                case SelectedPartnersTab.Partner:
                    navigate(
                        `./${Pages.REPORTING_PARTNERS}/${Pages.REPORTING_PARTNERS_PARTNER}`
                    )
                    break
                case SelectedPartnersTab.Individuals:
                    navigate(
                        `./${Pages.REPORTING_PARTNERS}/${Pages.REPORTING_PARTNERS_INDIVIDUALS}`
                    )
                    break
                case SelectedPartnersTab.Leaderboard:
                    navigate(
                        `./${Pages.REPORTING_PARTNERS}/${Pages.REPORTING_PARTNERS_LEADERBOARD}`
                    )
                    break
            }
        },
        [navigate, selectedTab]
    )

    return { selectedTab, tabOptions, onTabChange }
}

export default usePartnersPage
